function DashboardController(userViewService, stateService, accountService, toasterService, $translate, $interval) {
  const ctrl = this;

  ctrl.$onInit = () => {
    userViewService.setView('pis');
    ctrl.selectedWorkspace = stateService.getSelectedWorkspace();
    accountService.getCurrentUser().then(currentUser => {
      ctrl.currentUser = currentUser;
      fetchLockStatus();
      startPoll();
    });
  };

  ctrl.$onDestroy = () => {
    $interval.cancel(ctrl.lockStatusPromise);
    if (ctrl.hasLock) {
      unlockPisTool();
    }
  };

  const startPoll = () => {
    if (!ctrl.lockStatusPromise) {
      ctrl.lastLoad = DateTime.now();
      ctrl.lockStatusPromise = $interval(triggerFetchLoad, 10000);
    }
  };

  const triggerFetchLoad = () => {
    if (ctrl.lastLoad.diffNow('seconds').seconds < -9 && !ctrl.hasLock) {
      fetchLockStatus();
    }
  };

  const fetchLockStatus = () => {
    stateService.getPisLockStatus().then(pisLockStatus => {
      ctrl.pisLockStatus = pisLockStatus;
      setLockRights();
    });
  };

  const setLockRights = () => {
    if (ctrl.pisLockStatus.lockOwner && ctrl.pisLockStatus.lockOwner.email === ctrl.currentUser.email) {
      ctrl.hasLock = true;
    } else {
      ctrl.hasLock = false;
    }
  };

  const unlockPisTool = () => {
    stateService.unlockPisTool().then(res => {
      if (res.statusCode === 200) {
        stateService.setSelectedWorkspace(null);
        toasterService.success($translate.instant('toaster.pis-event'), $translate.instant('toaster.pis-unlock-successful'));
      } else {
        toasterService.error($translate.instant('toaster.pis-event'), $translate.instant('toaster.pis-unlock-failure'));
      }
    });
  };

  ctrl.onPisLock = event => {
    ctrl.pisLockStatus = event.pisLockStatus;
    ctrl.hasLock = event.hasLock;
  };

  ctrl.onWorkspaceSelect = event => {
    ctrl.selectedWorkspace = event.selectedWorkspace;
  };
}

angular
  .module('pis-tool.module')
  .controller('DashboardController', DashboardController);
